module.exports = __webpack_public_path__ + "static/orcs_war_wagon-f5b9897fd411897abd259d64f9ef1953.jpg";